import { Injectable } from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import type { TypeParams } from './types'

/** @see {@link ec.models.Api} */
@Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  /** @see {@link Api} */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(() =>
    rxjs.of(Array.from(ents.extra.quiver.getAllResources())),
  )

  /** @see {@link Api} */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('id', { name: 'ID' }),
      ec.models.Attribute.fromKey<TypeParams>('type', { name: 'Type' }),
    ])

  /** @see {@link Api} */
  public get: ec.models.Api<TypeParams>['get'] = (context, id) =>
    rxjs.of(ents.extra.quiver.getResource(id))
}
